import axios from "../utils/axios.instance";
import api from "../api";
import handleError from "./handle-error";

export const getSubscriptionPlans = async () => {
  try {
    const { data } = await axios.get(api.fetchSubscriptionPlansByType, {
      params: { type: "recurring" },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const purchaseSubscription = async (priceId, paymentMethodId) => {
  try {
    const { data } = await axios.post(api.createSubscription, {
      priceId,
      paymentMethodId,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const fetchActiveSubscription = async () => {
  try {
    const { data } = await axios.get(api.getActiveSubscription);
    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const cancelSubscription = async (subscriptionId) => {
  try {
    const { data } = await axios.put(
      `${api.cancelSubscription}/${subscriptionId}`
    );
    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const undoCancelSubcription = async (subscriptionId) => {
  try {
    const { data } = await axios.put(`${api.undoCancel}/${subscriptionId}`);
    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const changeSubscription = async (
  subscriptionId,
  priceId,
  paymentMetodId,
  isUpgrade
) => {
  try {
    const { data } = await axios.post(api.changeSubscription, {
      subscriptionId,
      priceId,
      paymentMetodId,
      isUpgrade,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
};

// PDF generation now handled on client via @react-pdf/renderer
